import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { Physics2DPlugin } from 'gsap/Physics2DPlugin'

gsap.registerPlugin(ScrollTrigger, Physics2DPlugin)

export const principles = () => {

  const el = document.querySelector('.principles')

  if (!el) return

  const entries = document.querySelectorAll('.principles__entry')

  entries.forEach(entry => {
    const images = entry.querySelectorAll('.principles__image-holder img')
    const imageHolders = entry.querySelectorAll('.principles__image-holder')
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: entry,
        start: 'top center',
        toggleActions: 'play none none reset'
      },
    })
    tl.fromTo(imageHolders, {
      scale: 0.5,
      display: 'none'
    }, {
      scale: 1,
      duration: 0.6,
      stagger: 0.3,
      display: 'block',
      ease: 'expo.out',
      overwrite: true
    })
    tl.fromTo(images, {
      scale: 1.5,
      display: 'none'
    }, {
      scale: 1,
      duration: 0.6,
      stagger: 0.3,
      display: 'block',
      ease: 'expo.out',
      overwrite: true
    }, '<')
    tl.fromTo(imageHolders, {
      opacity: 1
    }, {
      opacity: 0,
      duration: 0.95,
      stagger: -0.15,
      rotate: -10,
      clearProps: 'all',
      physics2D: {
        gravity: 2000
      }
    }, '-=0.25')
    tl.set([imageHolders, images], {
      clearProps: 'all'
    })
  })
  
}

export default () => {}